// Dependencies
import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

// Services
import { StudyContainerPageService } from './study-container-page.service';
import { StudyImageRequestService } from '../../services/study-image-request.service';
import { ActiveLanguageService } from '../../services/active-language.service';

@Component({
    selector: 'study-container-page',
    templateUrl: './study-container-page.html',
    styleUrls: ['./study-container-page.scss']
})
export class StudyContainerPageComponent {
    logoUrl: string;
    languages: Object[] = [];
    constructor(
        private activatedRoute: ActivatedRoute,
        private studyContainerPageService: StudyContainerPageService,
        private titleService: Title,
        private activeLanguage: ActiveLanguageService,
        private imageService: StudyImageRequestService) {}

    ngOnInit() {
        const paramObservable = Observable.combineLatest(
            this.activatedRoute.params,
            this.activatedRoute.queryParams,
            this.activeLanguage.current,
            (routeParams, queryParams, language) => ({ routeParams, queryParams, language })
        );

        paramObservable.subscribe(paramObject => {
            this.studyContainerPageService.setProperty('studyLanguage', paramObject.language);
            this.studyContainerPageService.setProperty('studySlugParam', paramObject.routeParams.studySlug);
            this.studyContainerPageService.setProperty('organizationIdParam', paramObject.queryParams.organization_id ? Number(paramObject.queryParams.organization_id) : null);
            this.studyContainerPageService.getStudyData(this.studyContainerPageService.studySlugParam, this.studyContainerPageService.organizationIdParam)
                .subscribe(response => {
                    const studyModel = response[0].data;
                    this.titleService.setTitle(studyModel.get('name'));
                    this.logoUrl = this.imageService.getImageUrl(studyModel.id, 'logo')
                    this.languages = studyModel.get('languages');
                    // If the study doesn't have any languages or doesn't have the currently selected one default back to english
                    if(this.languages.length == 0 || this.languages.find(function(language) { return language['code'] != paramObject.language; })) {
                        this.activeLanguage.set('en', false);
                    }

                    if(this.languages.length) {
                        this.languages.unshift({code:"", name:"English"});
                    }
                });
        });
    }

    //---------------------------------
    // Public
    //---------------------------------

}


// WEBPACK FOOTER //
// ./src/app/pages/study-container-page/study-container-page.component.ts